import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface FacetHit {
  value: string | number | boolean | null;
  count: number;
}

export interface GetCollectionFacetResponse {
  collection_name?: string;
  key?: string;
  hits: FacetHit[];
  detail?: string;
}

interface GetCollectionFacetProps {
  collectionId: string;
  field: string;
  limit?: number;
  exact?: boolean;
}

export const getCollectionFacet = async ({
  collectionId,
  field,
  limit = 100,
  exact = false,
}: GetCollectionFacetProps): Promise<GetCollectionFacetResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const params = new URLSearchParams({
    field,
    limit: String(limit),
    exact: String(exact),
  });

  const response = await apiRequest<GetCollectionFacetResponse>({
    url: `/collections/${orgId}/${collectionId}/facet?${params.toString()}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return (response?.data ?? response) as GetCollectionFacetResponse;
};
